module.exports = __webpack_public_path__ + "static/media/deckard_cain_monk_kr.b2b2464c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/deckardCain/deckard_cain_monk_kr.png
// module id = 35
// module chunks = 0